import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Paper,
  Typography } from
'@mui/material';
import { DeduplicationTask } from 'crqlar-react-common/dist/models/profile/deduplicationTask.model';
import { formatDuration, formatNumber } from './deduplicationUtils';

interface ClusteringPhaseCardProps {
  task: DeduplicationTask;
}

const ClusteringPhaseCard: React.FC<ClusteringPhaseCardProps> = ({ task }) => {
  const { t } = useTranslation();
  if (!task.clusteringStats) return null;
  const stats = task.clusteringStats;

  return (
    <Card variant="outlined" sx={{ mb: 3, p: 2 }}>
            <CardContent>
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>{t("Step 3: Clustering")}

        </Typography>
                <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>{t("Duration:")}
          {formatDuration(stats.durationMs)}
                </Typography>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={4}>
                        <Paper elevation={0} sx={{ bgcolor: 'background.default' }}>
                            <Typography variant="h6" color="primary" gutterBottom>{t("Total Clusters")}

              </Typography>
                            <Typography variant="h3" sx={{ fontWeight: 700 }}>
                                {formatNumber(stats.totalClusters)}
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Paper elevation={0} sx={{ bgcolor: 'background.default' }}>
                            <Typography variant="h6" color="primary" gutterBottom>{t("Mergeable")}

              </Typography>
                            <Typography variant="h3" sx={{ fontWeight: 700 }}>
                                {formatNumber(stats.mergeableClusters)}
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Paper elevation={0} sx={{ bgcolor: 'background.default' }}>
                            <Typography variant="h6" color="primary" gutterBottom>{t("Singletons")}

              </Typography>
                            <Typography variant="h3" sx={{ fontWeight: 700 }}>
                                {formatNumber(stats.singletonClusters)}
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>

                <Box sx={{ mt: 3 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="body2" color="text.secondary">{t("Average cluster size")}

              </Typography>
                            <Typography variant="h6">
                                {stats.avgClusterSize?.toFixed(2) || 'N/A'}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body2" color="text.secondary">{t("Max cluster size")}

              </Typography>
                            <Typography variant="h6">
                                {formatNumber(stats.maxClusterSize)}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body2" color="text.secondary">{t("Total family links")}

              </Typography>
                            <Typography variant="h6">
                                {formatNumber(stats.totalFamilyLinks)}
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>

                {stats.clusterTypeBreakdown && Object.keys(stats.clusterTypeBreakdown).length > 0 &&
        <Box sx={{ mt: 3 }}>
                        <Typography variant="subtitle1" gutterBottom>{t("Cluster Type Breakdown")}

          </Typography>
                        {Object.entries(stats.clusterTypeBreakdown).map(([type, count]) =>
          <Box key={type} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                <Typography variant="body2">{type}</Typography>
                                <Typography variant="body2" fontWeight={600}>{formatNumber(count)}</Typography>
                            </Box>
          )}
                    </Box>
        }
            </CardContent>
        </Card>);

};

export default ClusteringPhaseCard;
